module.exports = __webpack_public_path__ + "img/video.7a8d62e2.png";